import React from 'react';
// Import the CSS file for styling
import './Footer.css';
// Ensure Font Awesome is included in your project (e.g., via CDN or npm)
// Example using npm: import '@fortawesome/fontawesome-free/css/all.min.css';

function Footer() {
  const currentYear = new Date().getFullYear(); // Or use 2025 if it should be static like the image

  return (
    <footer className="curb-footer">
      <div className="footer-container">
        {/* --- Main Top Section --- */}
        <div className="footer-main">
          {/* Left Section: Logo & Contact Info */}
          <div className="footer-info">
            <div className="footer-logo">WakaForMe Ride</div> {/* Replace with <img> if needed */}
            <ul className="footer-contact-list">
              <li>
                <i className="fas fa-desktop footer-icon"></i> eFleet Access
              </li>
              <li>
                <i className="fas fa-list-alt footer-icon"></i> Lost & Found
              </li>
              <li>
                <i className="fas fa-receipt footer-icon"></i> Request a Trip Receipt
              </li>
              <li>
                <a href="mailto:support@gocurb.com">
                  <i className="fas fa-envelope footer-icon"></i> support@wakaforme.com
                </a>
              </li>
              <li>
                <a href="mailto:driver_support@gocurb.com">
                  <i className="fas fa-envelope footer-icon"></i> driver_support@wakaforme.com
                </a>
              </li>
              <li>
                <i className="fas fa-map-marker-alt footer-icon"></i> Plot 3, Opp. Govt. House Annex, Okefia Osogbo
              </li>
            </ul>
          </div>

          {/* Right Section: Link Columns */}
          <div className="footer-links-section">
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li><a href="#">Mobility</a></li>
                <li><a href="#">Fleet Systems</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">About Us</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Press & News</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact Us</h4>
              <ul>
                <li><a href="#">Lost Items</a></li>
                <li><a href="#">Rider App Support</a></li>
                <li><a href="#">Driver App Support</a></li>
                <li><a href="#">Systems Support</a></li>
                <li><a href="#">Feedback</a></li>
                <li><a href="#">Press</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Products</h4>
              <ul>
                <li><a href="#">Driver</a></li>
                <li><a href="#">Rider</a></li>
                <li><a href="#">Business</a></li>
                <li><a href="#">Ads</a></li>
                <li><a href="#">Partnerships</a></li>
                <li><a href="#">Concierge</a></li>
                <li><a href="#">Book a ride</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Others</h4>
              <ul>
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Terms of Use</a></li>
                <li><a href="#">Taxi Systems Terms</a></li>
              </ul>
            </div>
          </div>
        </div> {/* End footer-main */}

        {/* --- Bottom Section: Divider, Socials, Copyright --- */}
        <hr className="footer-divider" />
        <div className="footer-bottom">
          <div className="footer-socials">
            <a href="https://www.facebook.com/wakaforme" target='_blank' aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="https://x.com/wakaformeride" target='_blank' aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="https://www.linkedin.com" target='_blank' aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            {/* Assuming the last icon is Instagram */}
            <a href="https://www.instagram.com/wakaformeerrands?igsh=Mmk1ZHBlMzUwZ3Nx" target='_blank' aria-label="Instagram"><i className="fab fa-instagram"></i></a>
          </div>
          <div className="footer-copyright" style={{fontSize:'14px'}}>
            © {currentYear} WakaForMe Ride. All rights reserved. Powered by <a href="https://mactechnigeria.com" target="_blank" style={{color:'#FC8B24', textDecoration:'none'}}>MacTech Nigeria</a>
          </div>
        </div> {/* End footer-bottom */}

      </div> {/* End footer-container */}
    </footer>
  );
}

export default Footer;